module.exports = __webpack_public_path__ + "img/westminster-foundation-logo-square.0ea33d32.svg";